export function getStatusColor(percent: number | null | undefined) {
  if (!percent && percent !== 0) {
    return "text-secondary-foreground";
  }

  if (percent === 100) {
    return "text-status-green";
  }

  if (percent >= 60) {
    return "text-status-yellow";
  }

  return "text-status-red";
}

export function getStatusBorderColor(percent: number | null | undefined) {
  if (!percent && percent !== 0) {
    return "border-secondary-foreground";
  }

  if (percent === 100) {
    return "border-status-green";
  }

  if (percent >= 60) {
    return "border-status-yellow";
  }

  return "border-status-red";
}
